import OrderItem from "@/api/OrderItem";
import PaginatedList from "@/api/PaginatedList";
import OrderShipping from "@/api/OrderShipping";
import OrderPayment from "@/api/OrderPayment";

export class OrderDTO {
    public id?: number;
    public incrementId?: number;
    public dateTime = "";
    public status = "";
    public grandTotal = 0;
    public paymentRemaingTime =0;
    public items?: OrderItem[];
    public shipping?: OrderShipping;
    public payment?: OrderPayment;
}

export default class Order extends OrderDTO{
    constructor(dto: OrderDTO) {
        super();
        Object.assign(this, dto);
        if (this.shipping != undefined) {
            this.shipping = new OrderShipping(this.shipping);
        }
        if (this.payment != undefined) {
            this.payment = new OrderPayment(this.payment);
        }
        if(this.items != undefined) {
            this.items = this.items.map(orderItemDTO => new OrderItem(orderItemDTO));
        }
    }

    public getItemsCount(): number{
        if(this.items == undefined){
            return 0;
        }
        return this.items.length;
    }
}

export class PaginatedOrders implements PaginatedList{
    page?: number;
    perPage?: number;
    total?: number;
    orders: Order[] = [];
}